/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // QR redirect script
  const loadProductData = () => {
    if (!window.location.pathname.includes('/pages/anti-counterfeit-and-authenticity-assurance')) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    
    const brandName = params.get('customer_name');
    const serialNumber = params.get('serial_number');
    // const batchNumber = params.get('batch_number');
    const productCategory = params.get('part_category');
    const productHandle = params.get('part_desc');
    const token = params.get('token');
    
    if (!productHandle) {
      console.log('no handle')
      return;
    }

    fetch(`https://verify.aletheiafulfillment.com/api/v1/token?token=${token}`)
      .then(r => {
        if (!r.ok) {
          console.log('Token verification failed:', r.status);
          return;
        }
        return r.json();
      })
      .then(data => {
        if (!data) return;
        if (data.valid) {
          fetch(`/products/${productHandle}.js`)
            .then(response => response.json())
            .then(productData => {        
              const imgElement = document.querySelector('.image-with-text .lazy-image img');
              if (imgElement && productData.featured_image) {
                imgElement.src = productData.featured_image;
                imgElement.srcset = '';
                imgElement.alt = productData.title || 'Product image';
              }

              if (brandName) {
                document.getElementById('qr__brand-name').textContent = brandName;
              }
              document.getElementById('qr__serial-number').textContent = serialNumber || 'N/A';
              // document.getElementById('qr__batch-number').textContent = batchNumber || 'N/A';
              document.getElementById('qr__product-category').textContent = productCategory || 'N/A';
              document.getElementById('qr__description').textContent = productData.title || 'N/A';
            })
            .catch(error => {
              console.log(error)
            });
        } else {
          console.log('Invalid or expired token:', data.error);
        }
      })
      .catch(error => {
        console.log(error)
      });
  };
  document.addEventListener("DOMContentLoaded", loadProductData);




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
